var _path;
import * as React from "react";
function SvgWhiteWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 2,0 c 0.8985058,5.2114236 5.5451555,12.729721 9,13 v 9 h 1 1 V 13 C 17.626082,12.225887 21.941651,3.0666783 22,0 17.113636,0.15886848 12.482798,0.03662556 2,0 Z m 10,22 c -4.5032332,0 -8.0000003,1.249461 -8,2 5.0181747,0.03423 10.314143,0.228861 16,0 0,-0.750539 -3.496767,-2 -8,-2 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWine);
export default __webpack_public_path__ + "static/media/WhiteWine.c36fe8e415b73c781a2a845c9a0a70a4.svg";
export { ForwardRef as ReactComponent };